

const tServerMobileFaa = {
  path: "/faa/mobile",
  name: "faa_server",
  redirect: "/mobile_/Mobile_device_manage",
  component: () => import("@/viewsThreeServerFaa/home.vue"),
  children: [
    {
      path: "device_manage/:remoteld",
      name: "Mobile_device_manage_faa",
      component: () => import("@/viewsThreeServerFaa/deviceManage"),
      meta: { name: "设备流量管理", keepAlive: true }
    }
  ]

}
export default tServerMobileFaa;



// WEBPACK FOOTER //
// ./src/router/routerThreeServerFaa.js